import { useLocation, Navigate, Outlet } from 'react-router'
import { useAuth } from '../Hooks/useAuth'

const CheckAuth = () => {
  const location = useLocation()
  const { id } = useAuth()

  if (!id) {
    return <Navigate to="/login" state={{ from: location }} replace={true} />
  }

  return <Outlet />
}

export { CheckAuth }
